import React, {useEffect, useState} from 'react';
import Grid from '@mui/material/Grid2';
import { Fab, Tooltip } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete';
import { useLanguage } from 'Context/LanguageContext';
import { styled } from '@mui/material/styles';

const FloatingButton = styled(Fab)`
	background: #dc5c87 !important;
	position: relative;
	top: 200%;
	left: 30%;
	z-index: 8
`;

const FloatingButtonText = styled('span')`
	font-size: 11px;
`

const FielderFilePreview = ({ width, height, fileUrl, removeFile }) => {

	const [htmlContent, setHtmlContent] = useState(null);

	useEffect(() => {
		if(fileUrl.includes('.html')){
			const fileLinkAux = fileUrl.split(process.env.FIELDER_CONTENT_LINK);
			const archiveUrl = `https://${process.env.AWS_BUCKET}.s3.amazonaws.com${fileLinkAux[1]}`;

			fetch(archiveUrl)
			.then(res => res.text())
			.then(html => setHtmlContent(html));
		}
	}, [fileUrl]);

	const lan = useLanguage();

	const RemoveFileButton = () => (
		<Grid container direction='row'>
			<Grid size={3} className='ml-3'>
				<Tooltip title={lan.deleteFile}>
					<FloatingButton
						size='small'
						color='secondary'
						onClick={removeFile}
						variant='extended'
					>
						<DeleteIcon />
						<FloatingButtonText>{lan.deleteFile}</FloatingButtonText>
					</FloatingButton>
				</Tooltip>
			</Grid>
		</Grid>
	);

	return (
		<>
			{removeFile !== null && <RemoveFileButton />}

			<Grid container direction='row' justifyContent='center'>
				<Grid size={10}>
					{fileUrl.includes('.html') ? (
					<iframe
						srcDoc={htmlContent}
						width='100%'
						height='600px'
						style={{ border: 'none' }}
					>
						{' '}
					</iframe>
					) : (
						<iframe
						src={'https://view.officeapps.live.com/op/embed.aspx?src=' + fileUrl}
						width='100%'
						height='600px'
						style={{ border: 'none' }}
					>
						{' '}
					</iframe>
					)}
					
				</Grid>
			</Grid>
		</>
	);
};

FielderFilePreview.defaultProps = {
	width: '100%',
	height: '100%',
	fileUrl: null,
	removeFile: null,
};

export default FielderFilePreview;
